import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgCart = function SvgCart(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M23.663 6.492a.93.93 0 00-.17-.834 1.015 1.015 0 00-.793-.378H5.547a.247.247 0 01-.247-.192l-.572-2.611C4.406 1.037 3.084.007 1.55 0 .86 0 .3.537.3 1.2c0 .663.56 1.2 1.25 1.2a.745.745 0 01.733.576L5.45 17.442c.164.742.604 1.4 1.237 1.854.06.043.097.111.1.184a.235.235 0 01-.087.19 1.866 1.866 0 00-.309 2.581c.612.807 1.765 1.03 2.654.512.89-.517 1.217-1.602.755-2.496a.23.23 0 01.01-.233.255.255 0 01.214-.113h5.97c.086 0 .167.043.212.113.046.071.05.16.012.233-.307.595-.272 1.3.092 1.864a2.02 2.02 0 001.698.909 2.02 2.02 0 001.702-.914 1.853 1.853 0 00.083-1.87.223.223 0 01.01-.226.243.243 0 01.205-.11c.69 0 1.25-.537 1.25-1.2 0-.663-.56-1.2-1.25-1.2H8.63a.746.746 0 01-.734-.571l-.18-.821a.233.233 0 01.052-.2.254.254 0 01.194-.088h10.754c1.353 0 2.538-.87 2.894-2.123l2.052-7.225z"
  }));
};

export default SvgCart;